import { render, staticRenderFns } from "./mapThaigis.vue?vue&type=template&id=b32af120&scoped=true&"
import script from "./mapThaigis.vue?vue&type=script&lang=js&"
export * from "./mapThaigis.vue?vue&type=script&lang=js&"
import style0 from "./mapThaigis.vue?vue&type=style&index=0&id=b32af120&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32af120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
